<template>
  <ion-row
    class="mb-5"
    v-show="toggleShow && (typeClient === coupon_company || !coupon_company || typeMission === 'livraison')"
  >
    <ion-col>
      <ion-item class="item-border-grey item-floating">
        <ion-label position="floating">Client</ion-label>
        <ion-input
            mode="md"
            class="border-grey"
            :value="builder_name"
            required="true"
            disabled="true"
        ></ion-input>
      </ion-item>
    </ion-col>
  </ion-row>

  <ion-row class="mb-5" v-show="toggleShow">
    <ion-col>
      <ion-item class="item-floating">
        <ion-label position="floating">Chantier</ion-label>
        <ion-input
            name="worksite_name"
            mode="md"
            @ionChange="onChangeWorksiteName($event.target.value)"
            :value="worksite_name"
            :required="isWorksiteRequired"
            :disabled="oldRentalCouponSending"
        ></ion-input>
      </ion-item>
    </ion-col>
  </ion-row>
</template>

<script>
import {
  IonRow,
  IonCol,
  IonInput,
  IonLabel,
  IonItem,
} from '@ionic/vue';

export default {
  name: 'ClientDetails',
  components: {
    IonRow,
    IonCol,
    IonInput,
    IonLabel,
    IonItem,
  },
  props: [
    'toggleShow',
    'builder_name',
    'segmentContact',
    'contact_id',
    'supervisorsBuilder',
    'oldRentalCouponSending',
    'contact_name',
    'contact_email',
    'builder_id',
    'worksite_name',
    'typeVue',
    'status',
    'typeMission',
    'typeClient',
    'coupon_company',
    'source_signed',
  ],
  methods: {
    onChangeSegmentContact(value) {
      this.$emit('update:segmentContact', value);
      this.updateSegmentContact(value);
    },
    onChangeContactEmail(value) {
      this.$emit('update:contact_email', value);
    },
    onChangeWorksiteName(value) {
      this.$emit('update:worksite_name', value);
    },
  },

  computed: {
    isWorksiteRequired() {
      // if don't have either source_signature and no_source_signature and worksite is target it is not mandatory
      if (!this.source_signed && this.typeClient === 'target') return false;

      // transfer/delivery the only mandatory field is coupon_company one (source/target)
      if (this.typeClient === this.coupon_company) return true;

      // no coupon company or reservation, worksite is mandatory
      if (!this.coupon_company && this.typeMission === 'reservation')
        return true;

      return false;
    },
  },
};
</script>
